import {
  ActionCardData,
  ActionCardModel,
  assignConditionalItems,
  calculateScores,
  enableSeparator,
  recalculateFormulaNodes,
} from '@playbooks/action-cards-utils/src'

export default function handleActionCards(value: ActionCardData) {
  const actionCardModel = new ActionCardModel(value)

  recalculateFormulaNodes(actionCardModel)
  assignConditionalItems(actionCardModel)
  enableSeparator(value)
  calculateScores(value)
}
